
import { defineComponent, ref, watch } from 'vue'
import { useStore } from '@/store'
import { ToastOptions } from '@/components/Common/ToastOptions'

export default defineComponent({
    name: 'Toast',
    setup () {
        const store = useStore()
        const showToast = ref(false)
        const content = ref('')
        const toasts: ToastOptions[] = []
        let timeout: number

        watch(() => store.state.toast, (options?: ToastOptions) => {
            if (options) {
                toasts.push(options)

                if (toasts.length === 1) {
                    openToast(toasts[0])
                }
            }
        })

        const openToast = ({ data, ttl = 3000, theme = 'primary' }: ToastOptions) => {
            content.value = data
            showToast.value = true

            setTimeout(() => {
                const { style } = (document.querySelector('.toast') as HTMLDivElement)
                let backgroundColor = 'primary-color'
                let textColor = 'primary-text'

                switch (theme) {
                    case 'secondary':
                        backgroundColor = 'secondary-color'
                        textColor = 'secondary-text'
                        break

                    case 'error':
                        backgroundColor = 'danger-color'
                        textColor = 'default-color'
                        break
                }

                style.setProperty('--background-color', `var(--${backgroundColor})`)
                style.setProperty('--text-color', `var(--${textColor})`)
            }, 1)

            clearInterval(timeout)
            timeout = setTimeout(() => {
                dismissToast()
            }, ttl)
        }

        const dismissToast = () => {
            showToast.value = false
            clearTimeout(timeout)
        }

        const handleTransitionEnd = () => {
            toasts.splice(0, 1)

            if (toasts.length > 0) {
                openToast(toasts[0])
            }
        }

        return {
            showToast,
            content,
            openToast,
            dismissToast,
            handleTransitionEnd
        }
    }
})

